var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5928 85.1855C66.1161 85.1855 85.1855 66.1161 85.1855 42.5928C85.1855 19.0694 66.1161 0 42.5928 0C19.0694 0 0 19.0694 0 42.5928C0 66.1161 19.0694 85.1855 42.5928 85.1855Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6667 52.1306C45.5478 54.0117 45.5478 57.2364 43.6667 59.1174L39.7702 63.0139C37.8891 64.895 34.6644 64.895 32.7834 63.0139L15.7194 45.8156C13.8383 43.9345 13.8383 40.7099 15.7194 38.8288L19.6159 34.9323C21.497 33.0512 24.7217 33.0512 26.6027 34.9323L43.6667 52.1306Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5818 22.4367C60.4628 20.5556 63.6875 20.5556 65.5686 22.4367L69.4651 26.3332C71.3462 28.2142 71.3462 31.4389 69.4651 33.32L39.9055 62.7453C38.0244 64.6264 34.7997 64.6264 32.9186 62.7453L29.0221 58.8488C27.1411 56.9677 27.1411 53.743 29.0221 51.862L58.5818 22.4367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8c1a73b072c894bbba4b8c646da4e970.svg";
export { ForwardRef as ReactComponent };